import MultiForm from '@admin/components/multiform'
import PropTypes from 'prop-types'
import Details from './details'
import Library from './library'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    return {
      title: 't(New Form)',
      action: '/api/admin/truevail/agency/forms',
      method: 'POST',
      getSteps: this._getSteps,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getSteps() {
    return [
      { label: 't(Details)', component: Details },
      { label: 't(Library)', component: Library }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(form) {
    this.context.router.push(`/admin/truevail/agency/forms/${form.id}`)
    this.context.modal.close()
  }

}

export default New
